var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-wrap"},[_c('div',{staticClass:"logo"}),_c('h6',[_vm._v("呼呼打药")]),_c('p',{staticClass:"p1"},[_vm._v("体验非农户身份功能")]),_c('p',{staticClass:"p2"},[_vm._v("请下载呼呼打药APP")]),_c('DownApp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }